module.exports = __webpack_public_path__ + "static/media/Modernism_tv_gif.9f6807d7.gif";